<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4>Cadastrar Corretor</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label for="nome">Nome</label>
            <input
              id="nome"
              type="text"
              class="form-control"
              placeholder="Digite um nome:"
              v-model="state.nome.value"
            />
            <span v-if="state.nome.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-2">
            <label for="descricao">Pagante</label>
            <select class="form-select" v-model="state.destaque">
              <option value="SIM">Sim</option>
              <option value="NAO">Não</option>
            </select>
          </div>
          <div class="col-md-2">
            <label for="nacional">Nacional</label>
            <select class="form-select" v-model="state.nacional">
              <option value="SIM">Sim</option>
              <option value="NAO">Não</option>
            </select>
          </div>
          <div class="col-md-2">
            <label for="nacional">Tipo Pessoa</label>
            <select class="form-select" v-model="state.tipo_pessoa">
              <option value="FISICA">Física</option>
              <option value="JURIDICA">Jurídica</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <label for="telefone">Telefone</label>
            <input
              id="telefone"
              type="text"
              class="form-control"
              placeholder="Digite um telefone:"
              v-model="state.telefone.value"
              v-mask-phone.br
            />
            <span v-if="state.telefone.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-3">
            <label for="email">E-mail</label>
            <input
              id="email"
              type="email"
              class="form-control"
              placeholder="Digite um email:"
              v-model="state.email.value"
            />
            <span v-if="state.email.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-3" v-if="state.tipo_pessoa == 'FISICA'">
            <label for="cpf">CPF</label>
            <input
              id="cpf"
              type="text"
              class="form-control"
              placeholder="Digite o CPF:"
              v-model="state.cpf.value"
              v-mask-cpf
            />
            <span v-if="state.cpf.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-3" v-if="state.tipo_pessoa == 'JURIDICA'">
            <label for="cnpj">CNPJ</label>
            <input
              id="cnpj"
              type="text"
              class="form-control"
              placeholder="Digite o CNPJ:"
              v-model="state.cnpj.value"
              v-mask-cnpj
            />
            <span v-if="state.cnpj.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <label>Estado</label>
            <select
              class="form-select"
              @change="fetchCidade($event.target.value)"
              v-model="state.estado_id"
            >
              >
              <option
                :value="estado.id"
                v-for="estado in state.estados"
                :key="estado.id"
              >
                {{ estado.nome }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label for="numero">Cidade</label>
            <select class="form-select" v-model="state.cidade_id.value">
              <option
                :value="cidade.id"
                v-for="cidade in state.cidades"
                :key="cidade.id"
              >
                {{ cidade.nome }}
              </option>
            </select>
            <span v-if="state.cidade_id.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-3">
            <label for="numero">CEP</label>
            <input
              type="text"
              class="form-control"
              placeholder="Digite o CEP:"
              v-model="state.cep.value"
              v-mask-cep
            />
            <span v-if="state.cep.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="numero">Endereço</label>
            <input
              type="text"
              class="form-control"
              placeholder="Digite o Endereço:"
              v-model="state.endereco.value"
            />
            <span v-if="state.endereco.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-2">
            <label for="numero">Número</label>
            <input
              type="text"
              class="form-control"
              placeholder="Digite o Número:"
              v-model="state.numero.value"
            />
            <span v-if="state.numero.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-3">
            <label for="numero">Bairro</label>
            <input
              type="text"
              class="form-control"
              placeholder="Digite o Bairro:"
              v-model="state.bairro.value"
            />
            <span v-if="state.bairro.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label>Imagem</label>
            <input type="file" class="form-control" @change="adicionarImagem" />
            <span v-if="state.erro_imagem" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div
            style="display: flex"
            class="col-md-4"
            v-if="state.imagem.imagem"
          >
            <img :src="state.imagem.imagem" class="imagem" />
            <button class="btn_deletar_imagem" @click="removerImagem">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                fill="currentColor"
                class="bi bi-x-lg mb-2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
                />
              </svg>
            </button>
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarCorretor" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/corretores">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      destaque: "NAO",
      nacional: "NAO",
      tipo_pessoa: "FISICA",
      nome: {
        value: "",
        error: false,
      },
      telefone: {
        value: "",
        error: false,
      },
      email: {
        value: "",
        error: false,
      },
      cpf: {
        value: "",
        error: false,
      },
      cnpj: {
        value: "",
        error: false,
      },
      cep: {
        value: "",
        error: false,
      },
      erro_imagem: false,
      imagem: {},
      endereco: {
        value: "",
        error: false,
      },
      numero: {
        value: "",
        error: false,
      },
      bairro: {
        value: "",
        error: false,
      },
      cidade_id: {
        value: "",
        error: false,
      },
      estado_id: "",
    });
    onMounted(() => {
      fetchEstados();
      if (router.currentRoute._value.params.id != undefined) {
        fetchCorretor();
      }
    });
    async function fetchCorretor() {
      try {
        const { data } = await services.corretor.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.nome.value = data.nome;
        state.destaque = data.destaque;
        state.nacional = data.nacional;
        state.tipo_pessoa = data.tipo_pessoa;
        if (data.cpf != null) {
          state.cpf.value = data.cpf;
        }
        if (data.cnpj != null) {
          state.cnpj.value = data.cnpj;
        }
        state.telefone.value = data.telefone;
        state.email.value = data.email;
        state.estado_id = data.cidade.estado_id;
        state.cep.value = data.cep;
        state.endereco.value = data.endereco;
        state.bairro.value = data.bairro;
        state.numero.value = data.numero;
        fetchCidade(state.estado_id);
        state.cidade_id.value = data.cidade_id;
        if (data.imagem != null) {
          state.imagem.imagem = data.imagem;
        }
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchCidade(estado_id) {
      try {
        const { data } = await services.estado.getCidades({
          estado_id,
          token,
        });
        state.cidades = data.data;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarCorretor() {
      var erro_validacao = false;

      if (state.nome.value.length == 0) {
        state.nome.error = true;
        erro_validacao = true;
      }
      if (state.tipo_pessoa == "FISICA" && state.cpf.value.length == 0) {
        state.cpf.error = true;
        erro_validacao = true;
      }
      if (state.tipo_pessoa == "JURIDICA" && state.cnpj.value.length == 0) {
        state.cnpj.error = true;
        erro_validacao = true;
      }
      if (state.imagem.imagem == null || state.imagem.imagem == undefined) {
        state.erro_imagem = true;
        erro_validacao = true;
      }

      if (state.cep.value.length == 0) {
        state.cep.error = true;
        erro_validacao = true;
      }
      if (state.endereco.value.length == 0) {
        state.endereco.error = true;
        erro_validacao = true;
      }

      if (state.numero.value.length == 0) {
        state.numero.error = true;
        erro_validacao = true;
      }

      if (state.bairro.value.length == 0) {
        state.bairro.error = true;
        erro_validacao = true;
      }

      if (erro_validacao == true) {
        return;
      }
      var value = state.telefone.value;
      var clean = value.replace(/[^0-9,]*/g, "");

      let dados = new FormData();
      if (state.tipo_pessoa == "FISICA") {
        dados.append("cpf", state.cpf.value);
      }
      if (state.tipo_pessoa == "JURIDICA") {
        dados.append("cnpj", state.cnpj.value);
      }
      dados.append("nome", state.nome.value);
      dados.append("destaque", state.destaque);
      dados.append("nacional", state.nacional);
      dados.append("tipo_pessoa", state.tipo_pessoa);
      dados.append("telefone", clean);
      dados.append("email", state.email.value);
      dados.append("cidade_id", state.cidade_id.value);
      dados.append("cep", state.cep.value);
      dados.append("endereco", state.endereco.value);
      dados.append("numero", state.numero.value);
      dados.append("bairro", state.bairro.value);

      if (state.imagem.file != null) {
        dados.append("imagem", state.imagem.file);
      }

      if (!state.id) {
        await services.corretor
          .save({ dados, token })
          .then((data) => {
            console.log(data);
            router.push({ name: "Corretores" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      } else {
        dados.append("id", state.id);
        dados.append("_method", "PATCH");
        if (state.imagem.imagem == undefined) {
          try {
            await services.corretor.deletarImagem({
              id: dados.get("id"),
            });
          } catch (error) {
            console.log(error);
          }
        }
        await services.corretor
          .update({ dados, token })
          .then((data) => {
            console.log(data);
            router.push({ name: "Corretores" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      }
    }
    async function fetchEstados() {
      try {
        const { data } = await services.estado.getAll({
          token,
        });
        console.log(data);
        state.estados = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function adicionarThumbnail(event) {
      var thumb = event.target.files[0];
      var objThumb = new Object();
      objThumb.file = thumb;
      objThumb.thumbnail = URL.createObjectURL(thumb);
      state.thumbnail = objThumb;
    }
    async function adicionarImagem(event) {
      var img = event.target.files[0];

      var objImagem = new Object();
      objImagem.file = img;
      objImagem.imagem = URL.createObjectURL(img);
      state.imagem = objImagem;
    }
    async function removerThumbnail() {
      state.thumbnail = {};
      document.querySelector('input[type="file"]').value = null;
    }
    async function removerImagem() {
      state.imagem = {};
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      salvarCorretor,
      removerImagem,
      removerThumbnail,
      adicionarImagem,
      adicionarThumbnail,
      fetchEstados,
      fetchCidade,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}

label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}

input {
  border: solid 1px #000;
}

input:focus {
  border: solid 1px #47b0a9;
}

select {
  border: solid 1px #000;
}

select:focus {
  border: solid 1px #47b0a9;
}

.btns_right {
  text-align: right;
  margin-top: 1rem;
}

.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_save:hover {
  background: #008000;
}

.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn_cancel:hover {
  background: #8f0303;
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}

textarea {
  resize: none;
  border: solid 1px #000;
}

textarea:focus {
  border: solid 1px #47b0a9;
}

#pills-home-tab {
  color: #000;
}

#pills-home-tab:focus {
  color: #47b0a9;
}

#pills-profile-tab {
  color: #000000;
}

#pills-profile-tab:focus {
  color: #47b0a9;
}

.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}

tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}

thead {
  color: #000;
  text-align: center;
  background: gray;
}

td {
  color: #000;
  text-align: center;
}

.table {
  margin-top: 2rem;
}

.imagem {
  width: 100%;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
}

.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}

.imagem {
  width: 200px;
  height: 200px;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
  border-radius: 100%;
}
</style>